import { useEffect } from 'react';
import { TFocusableElement, useFocusContext } from 'src/contexts/FocusContext';

export const useFocusableGroups = (groups: TFocusableElement['group'][]) => {
  const { makeOnlySomeElementGroupsFocusable, makeAllElementGroupsFocusable } = useFocusContext();

  useEffect(() => {
    makeOnlySomeElementGroupsFocusable(groups);

    return () => {
      makeAllElementGroupsFocusable();
    };
  }, []);
};
